export const API_COUNT: string = 'APICount';
export const API_SUCCESS: string = 'APISuccess';
export const API_ERROR: string = 'APIError';
export const API_LATENCY: string = 'APILatency';

export const APP_INITIALIZED_EVENT: string = 'AppInitialized';
export const PAGE_LOAD_EVENT: string = 'PageLoad';
export const RENDER_ERROR_EVENT: string = 'RenderError';
export const USER_CLICK_EVENT: string = 'UserClick';

export const UNKNOWN_API_NAME: string = 'UNKNOWN_API';
export const UNKNOWN_COMPONENT: string = 'UNKNOWN_COMPONENT';

export const HOMEPAGE_PAGE_GROUP = 'homepage';
export const NAV_LAYOUT_PAGE_GROUP = 'navlayout';
export const NOT_FOUND_PAGE_GROUP = 'notfound';
export const OPT_IN_PAGE_GROUP = 'optin';
export const UNSUBSCRIBE_PAGE_GROUP = 'unsubscribe';
